module.exports = __webpack_public_path__ + "img/Checklist.423c4dac.svg";